/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 1b8b3abca32e2944b8fba3ab2fea012630968b0b
 */

/**
 * Controls how a section is presented in the client.
 */
export type DisplayMode = typeof DisplayMode[keyof typeof DisplayMode];


export const DisplayMode = {
  banner: 'banner',
  special: 'special',
  regular: 'regular',
} as const;
